import { postData } from "./PostData";

export const searchForm = () => {
	
	window.searchForm = () => {
		return {
			results: [],
			value: '',
			submit() {
				if (this.value.length >=3) {
			
					document.getElementById('loader').style.display = 'flex';
				
					const form = new FormData();
					form.append( 'action', 'search_form' );
					form.append( 's', this.value );
					form.append( '_ajax_nonce', my_ajax_object.coffeeloft_nonce );
				
					const params = new URLSearchParams(form);
				
					postData( my_ajax_object.ajax_url, params)
						.then(response => {
							document.getElementById('loader').style.display = 'none';

							if (!response || response.error) {
								return;
							}

							this.results = response.results;
						});
				} else {
					this.results = [];
				}
			}
		}
	}
}
